import { useState } from 'react';
import { ChevronDown, Download, FileSpreadsheet, FileText, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { downloadExport } from '../../utils/exportDownload';

/**
 * LOT A — Bouton d'export unique proposant Excel (.xlsx structuré) et CSV.
 */
export const ExportFormatMenu = ({
  endpoint,
  filenameBase,
  label = 'Exporter',
  testId = 'export',
  variant = 'outline',
  size,
  className,
  axiosConfig,
  onToast,
}) => {
  const [busy, setBusy] = useState(false);

  const run = async (format) => {
    setBusy(true);
    try {
      await downloadExport(endpoint, { format, filenameBase, axiosConfig });
      onToast?.({ title: format === 'xlsx' ? 'Export Excel lancé' : 'Export CSV lancé' });
    } catch {
      onToast?.({ title: 'Erreur export', variant: 'destructive' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size} className={className} disabled={busy} data-testid={`${testId}-menu-btn`}>
          {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Download className="w-4 h-4 mr-2" />}
          {label}
          <ChevronDown className="w-3 h-3 ml-1.5 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel className="text-xs text-slate-500">Format d'export</DropdownMenuLabel>
        <DropdownMenuItem onClick={() => run('xlsx')} data-testid={`${testId}-xlsx-btn`} className="gap-2">
          <FileSpreadsheet className="w-4 h-4 text-emerald-600" />
          <span className="flex flex-col">
            <span>Excel (.xlsx)</span>
            <span className="text-xs text-slate-400">Mis en forme, montants calculables</span>
          </span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => run('csv')} data-testid={`${testId}-csv-btn`} className="gap-2">
          <FileText className="w-4 h-4 text-slate-500" />
          <span className="flex flex-col">
            <span>CSV (.csv)</span>
            <span className="text-xs text-slate-400">Import comptable / ERP</span>
          </span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportFormatMenu;
